/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Xmlid6615IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Xmlid6615Icon(props: Xmlid6615IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 128 414"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M117.595 405.999c-2.706 6.954-10.948 9.893-17.471 6.269l-25.406-14.114c-5.023-2.79-7.381-8.778-5.521-14.214 5.888-17.219 13.737-55.967-17.686-90.45-52.81-57.953-30.076-104.328-11.808-141.588 6.338-12.929 12.326-25.141 15.983-38.23 6.911-24.729-29.284-52.693-49.861-65.547C.393 44.73-1.562 37.77 1.34 32.06L14.2 6.757c3.247-6.385 11.233-8.689 17.36-4.98 9.494 5.748 23.5 15.08 36.812 27.155 43.516 39.467 44.861 75.619 38.326 98.997-4.968 17.778-12.654 33.455-19.436 47.289-17.26 35.208-25.138 51.278 3.4 82.596 28.068 30.802 40.686 68.386 36.488 108.685-1.72 16.513-5.951 30.236-9.554 39.5z"
        }
      ></path>
    </svg>
  );
}

export default Xmlid6615Icon;
/* prettier-ignore-end */
